import { createResponseTransformer } from "shared/api/createResponseTransformer"
import {
  ProjectImportsAPIType,
  serializer
} from "shared/api/serializer/serializer"
import { transformJsonApiResponse } from "shared/api/transformJsonApiResponse"

export const projectImportResponseTransformer = createResponseTransformer(
  json => {
    return serializer.deserialize(
      ProjectImportsAPIType,
      transformJsonApiResponse(json)
    )
  }
)
